import urlJoin from 'url-join';
import GLOBAL_URLS from '../../urls';

export const BASE_URL = GLOBAL_URLS.authSection;

export const LOGIN = urlJoin(BASE_URL, 'login');
export const CONFIRM_LOGIN = urlJoin(BASE_URL, 'login/confirm');
export const FORGOT_PASSWORD = urlJoin(BASE_URL, 'forgot');
export const RESET_PASSWORD = urlJoin(BASE_URL, 'forgot/confirm');
